import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getCancelaciones } from '../../../../service/reportes/Cancelaciones';
import { getCambioSim } from '../../../../service/reportes/CambioSim';
import { getSelectUser } from '../../../../service/reportes/Activaciones';

export const useGetAll = (realoadGrid: number, filters: any) => {
  const [data, setData] = useState<any[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(0);
  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      const res = await getCambioSim(filters)
        .then()
        .catch((error) => {
          history.push('/error/500');
        });
      if (res) {
        setData(res.rows);
        setLoadingRequest(1);
      }
    };
    if (realoadGrid) {
      fetchPost();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, realoadGrid]);
  return { data, loadingRequest };
};
